// Imports
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".g5rWJOznbJ5zqK {\n  height: 20px;\n  border-radius: 3px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  flex-direction: column;\n  overflow: hidden;\n  width: 70%;\n  margin: 0 auto;\n}\n.g5rWJOznbJ5zqK::before {\n  content: '';\n  display: block;\n  width: 100%;\n}\n._0ISORPVr7208C-::before {\n  border-top: 2px solid var(--ds-border, #C1C7D0);\n}\n", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"separatorCard": "g5rWJOznbJ5zqK",
	"singleHorizontalLine": "_0ISORPVr7208C-"
};
export default ___CSS_LOADER_EXPORT___;
